import { Alert, AlertTitle, Grid } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { Outlet, useLocation } from "react-router-dom";
import { VideoPlayer } from "../../components/common";

const Video = () => {
  const { t } = useTranslation("page");
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  // Get video source path
  const videoPath = location.search.split("src=")[1] || "";
  const videoTitle = params.get("id") || "video_title";
  const videoId = params.get("videoId");

  return (
    <Grid>
      {!videoPath && (
        <Alert severity="warning">
          <AlertTitle>{t("video.warning")}</AlertTitle>
          {t("video.unableToLocateChannel")}
        </Alert>
      )}

      <Grid item>
        <VideoPlayer
          videoId={videoId}
          src={videoPath}
          name={videoTitle}
          originalName={videoPath.split("/").pop() || ""}
          rootPath={videoPath.split("/")[1] || ""}
        />
      </Grid>

      <Outlet />
    </Grid>
  );
};

export default Video;
